import { useRef, type ReactNode } from "react";
import { useLocation } from "react-router";
import { useAuth } from "@/app/providers/AuthProvider";
import { mainAreaReserve, mainScrollerStyle } from "./main-scroller";
import { useScreenScroll } from "./useScreenScroll";

/**
 * Belgenin TEK `<main>`'i — uygulamanın kayan öğesi.
 *
 * AYRI BİR BİLEŞEN, çünkü sohbet düğmesinin alt rezervi burada bağlanıyor ve bu bağ ölçülmeliydi
 * (bağımsız inceleme, Sohbet 21): `AppLayout`'tan `style` satırı sökülünce bütün testler yeşil
 * kalıyordu — yalnız `mainScrollerStyle` fonksiyonu sınanıyordu, `<main>`'e verilip verilmediği
 * değil. Kabuğun tamamını testte çizmek yerine bağ buraya taşındı ve `MainScroller.test.tsx`
 * gerçek `<main>`'i çiziyor.
 *
 * Görünürlük kuralı düğmeninkiyle AYNI fonksiyon (`chatLauncherVisible`): düğme ile rezerv
 * birbirinden kayamaz. `<main>`'i tamamen dolduran ekranlarda (Notlarım, belge düzenleyici)
 * rezerv `<main>`'de değil, o ekranın iç kaydırıcısında (`fillsMainArea`).
 */
export function MainScroller({ children }: { children: ReactNode }) {
  const { permissions } = useAuth();
  const { pathname } = useLocation();
  /** Yeni ekran üstten, geri dönülen ekran bırakıldığı yerden; kaybolan odak `<main>`'e (`useScreenScroll`). */
  const ref = useRef<HTMLElement | null>(null);
  useScreenScroll(ref);

  return (
    <main
      ref={ref}
      id="main"
      /**
       * «İçeriğe atla»nın hedefi (8 Ekim 2026): bağlantı odağı buraya koyuyor ki sonraki Tab
       * sayfanın içinden devam etsin. `-1`: sekme sırasına girmiyor, yalnız programla odaklanıyor.
       */
      tabIndex={-1}
      /**
       * `relative` (20 Ekim 2026): içerikteki `sr-only` etiketler (`position: absolute`) konumlandırılmış
       * bir ata bulamayınca `<main>`'in kırpmasından kaçıyor ve belgeyi uzatıyordu (Panelim: pencere 900 px,
       * belge 1794 px). İçerik sonuna gelince kaydırma pencereye geçiyor, kabuk yukarı kayıp altta boş
       * bir şerit bırakıyordu (kullanıcı ekran görüntüsü, Safari'de belirgin).
       */
      className="relative min-w-0 flex-1 overflow-y-auto overscroll-contain"
      style={mainScrollerStyle(mainAreaReserve({ permissions, pathname }))}
    >
      {children}
    </main>
  );
}
